import * as React from 'react';
import { clsx } from 'clsx';
import * as styles from './styles.module.css';
import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Компонент для визуального разделения контента.
 *
 * [Ссылка на макет](https://www.figma.com/design/6gBJmj1QhbJqC50FHo75St/%F0%9F%8C%90-Divider)
 */
export const Divider = _ref => {
  let {
    direction = 'horizontal',
    colorType = 'default',
    dashPattern = 'solid'
  } = _ref;
  return /*#__PURE__*/_jsx("div", {
    role: "separator",
    className: clsx(styles['divider'], styles[direction], styles["dashPattern_".concat(dashPattern)], styles[colorType])
  });
};